import { render, staticRenderFns } from "./editChapter.vue?vue&type=template&id=2b3fb858"
import script from "./editChapter.vue?vue&type=script&lang=js"
export * from "./editChapter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports